<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('shopAudit.title') }}</span>
        <el-button type="warning" style="float: right; margin-left: 20px;" @click="goBack">
          {{ $t('shopAudit.back') }}
        </el-button>
      </div>
      <div class="card-body">
        <el-form :model="shopAuditDetailInfo" class="text-left" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('shopAudit.shopName')">
                <span>{{ shopAuditDetailInfo.shopName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('shopAudit.shopDesc')">
                <span>{{ shopAuditDetailInfo.shopDesc }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('shopAudit.shopType')">
                <span>{{ shopAuditDetailInfo.shopTypeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('shopAudit.openType')">
                <span>{{ openTypeName(shopAuditDetailInfo.openType) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('shopAudit.logo')">
                <el-image style="width: 60px; height: 60px; border-radius: 5px;" :src="shopAuditDetailInfo.shopLogo"
                  fit="cover"></el-image>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('shopAudit.sendAddress')">
                <span>{{ shopAuditDetailInfo.sendAddress }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('shopAudit.areaName')">
                <span>{{ shopAuditDetailInfo.areaName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('shopAudit.returnAddress')">
                <span>{{ shopAuditDetailInfo.returnAddress }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('shopAudit.returnPerson')">
                <span>{{ shopAuditDetailInfo.returnPerson }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('shopAudit.returnLink')">
                <span>{{ shopAuditDetailInfo.returnLink }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('shopAudit.applyOpinion')">
                <span>{{ shopAuditDetailInfo.applyOpinion }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="shopAuditDetailInfo.state === '003'">
            <el-col :span="24">
              <el-form-item :label="$t('shopAudit.auditOpinion')">
                <span>{{ shopAuditDetailInfo.auditOpinion }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card v-if="shopAuditDetailInfo.state === '001'" class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('shopAudit.auditResult') }}</span>
      </div>
      <div class="card-body">
        <el-form :model="auditInfo" label-width="120px">
          <el-form-item :label="$t('shopAudit.auditStatus')">
            <el-select v-model="auditInfo.state" style="width: 100%;" :placeholder="$t('shopAudit.selectAuditStatus')">
              <el-option :label="$t('shopAudit.agree')" value="1100"></el-option>
              <el-option :label="$t('shopAudit.reject')" value="1200"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shopAudit.auditOpinion')">
            <el-input type="textarea" :placeholder="$t('shopAudit.auditOpinionPlaceholder')"
              v-model="auditInfo.auditOpinion" :rows="4"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="auditSubmit">
              {{ $t('shopAudit.submit') }}
            </el-button>
            <el-button type="warning" style="margin-left: 20px;" @click="refreshShopAuditManageInfo">
              {{ $t('shopAudit.cancel') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryShopAudit, auditEditShop } from '@/api/shop/shopAuditApi'

export default {
  name: 'ShopAuditDetail',
  data() {
    return {
      shopAuditDetailInfo: {
        auditId: '',
        shopId: '',
        shopLogo: '',
        storeId: '',
        shopName: '',
        shopDesc: '',
        mapX: '',
        mapY: '',
        sendAddress: '',
        returnAddress: '',
        shopTypeName: '',
        areaName: '',
        returnPerson: '',
        returnLink: '',
        state: '',
        shopType: '',
        openType: '',
        areaCode: '',
        auditOpinion: '',
        applyOpinion: '',
        statusCd: ''
      },
      auditInfo: {
        state: '',
        auditOpinion: ''
      }
    }
  },
  created() {
    this.shopAuditDetailInfo.auditId = this.$route.query.auditId
    this.shopAuditDetailInfo.shopId = this.$route.query.shopId
    this.loadShopAuditInfoData()
  },
  methods: {
    loadShopAuditInfoData() {
      const params = {
        page: 1,
        row: 1,
        auditId: this.shopAuditDetailInfo.auditId
      }
      queryShopAudit(params).then(res => {
        Object.assign(this.shopAuditDetailInfo, res.data[0])
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    auditSubmit() {
      if (!this.auditValidate()) {
        this.$message.error(this.validateErrInfo)
        return
      }

      const params = {
        state: this.auditInfo.state,
        auditOpinion: this.auditInfo.state === '1200'
          ? `拒绝:${this.auditInfo.auditOpinion}`
          : this.auditInfo.auditOpinion,
        shopId: this.shopAuditDetailInfo.shopId,
        storeId: this.shopAuditDetailInfo.storeId,
        auditId: this.shopAuditDetailInfo.auditId,
        remark: this.auditInfo.auditOpinion
      }

      auditEditShop(params).then(res => {
        if (res.code !== 0) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('处理成功')
        this.goBack()
      }).catch(error => {
        this.$message.error(`处理失败:${error}`)
      })
    },
    openTypeName(state) {
      const typeMap = {
        '1': this.$t('shopAudit.merchant'),
        '2': this.$t('shopAudit.service'),
        '3': this.$t('shopAudit.merchantAndService')
      }
      return typeMap[state] || ''
    },
    auditValidate() {
      // 这里应该实现验证逻辑
      return true
    },
    goBack() {
      this.$router.go(-1)
    },
    refreshShopAuditManageInfo() {
      this.auditInfo = {
        state: '',
        auditOpinion: ''
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>